// eslint-disable-next-line
let routes = [
  {
    path: '/admin/users',
    name: 'admin.users.index',
    component: () => import('@/pages/Admin/Users/Index'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/users/create',
    name: 'admin.users.create',
    component: () => import('@/pages/Admin/Users/Create'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/users/:id',
    name: 'admin.users.edit',
    component: () => import('@/pages/Admin/Users/Edit'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/types',
    name: 'admin.types.index',
    component: () => import('@/pages/Admin/Types/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/types/create',
    name: 'admin.types.create',
    component: () => import('@/pages/Admin/Types/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/types/:id',
    name: 'admin.types.edit',
    component: () => import('@/pages/Admin/Types/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/countries',
    name: 'admin.countries.index',
    component: () => import('@/pages/Admin/Countries/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/countries/create',
    name: 'admin.countries.create',
    component: () => import('@/pages/Admin/Countries/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/countries/:id',
    name: 'admin.countries.edit',
    component: () => import('@/pages/Admin/Countries/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/text-modules',
    name: 'admin.text-modules.index',
    component: () => import('@/pages/Admin/TextModules/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/text-modules/create/:id?',
    name: 'admin.text-modules.create',
    component: () => import('@/pages/Admin/TextModules/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/text-modules/:id',
    name: 'admin.text-modules.edit',
    component: () => import('@/pages/Admin/TextModules/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/templates',
    name: 'admin.templates.index',
    component: () => import('@/pages/Admin/Templates/Index'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/templates/create/:id?',
    name: 'admin.templates.create',
    component: () => import('@/pages/Admin/Templates/Create'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/templates/:id',
    name: 'admin.templates.edit',
    component: () => import('@/pages/Admin/Templates/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/truck-sharing-pages',
    name: 'admin.truck-sharing-pages.index',
    component: () => import('@/pages/Admin/TruckSharingPages/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/truck-sharing-pages/create/:id?',
    name: 'admin.truck-sharing-pages.create',
    component: () => import('@/pages/Admin/TruckSharingPages/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/truck-sharing-pages/:id',
    name: 'admin.truck-sharing-pages.edit',
    component: () => import('@/pages/Admin/TruckSharingPages/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tp-email-templates',
    name: 'admin.tp-email-templates.index',
    component: () => import('@/pages/Admin/TpEmailTemplates/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tp-email-templates/create/:id?',
    name: 'admin.tp-email-templates.create',
    component: () => import('@/pages/Admin/TpEmailTemplates/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tp-email-templates/:id',
    name: 'admin.tp-email-templates.edit',
    component: () => import('@/pages/Admin/TpEmailTemplates/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/offer-footers',
    name: 'admin.offer-footers.index',
    component: () => import('@/pages/Admin/OfferFooters/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/offer-footers/create/:id?',
    name: 'admin.offer-footers.create',
    component: () => import('@/pages/Admin/OfferFooters/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/offer-footers/:id',
    name: 'admin.offer-footers.edit',
    component: () => import('@/pages/Admin/OfferFooters/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/offer-standard-texts',
    name: 'admin.offer-standard-texts.index',
    component: () => import('@/pages/Admin/OfferStandardTexts/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/offer-standard-texts/create/:id?',
    name: 'admin.offer-standard-texts.create',
    component: () => import('@/pages/Admin/OfferStandardTexts/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/offer-standard-texts/:id',
    name: 'admin.offer-standard-texts.edit',
    component: () => import('@/pages/Admin/OfferStandardTexts/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/banners',
    name: 'admin.banners.index',
    component: () => import('@/pages/Admin/Banners/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/banners/create',
    name: 'admin.banners.create',
    component: () => import('@/pages/Admin/Banners/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/banners/:id',
    name: 'admin.banners.edit',
    component: () => import('@/pages/Admin/Banners/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/okr-banners',
    name: 'admin.okr-banners.index',
    component: () => import('@/pages/Admin/OkrBanners/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/okr-banners/create',
    name: 'admin.okr-banners.create',
    component: () => import('@/pages/Admin/OkrBanners/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/okr-banners/:id',
    name: 'admin.okr-banners.edit',
    component: () => import('@/pages/Admin/OkrBanners/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  // OKR teams

  {
    path: '/admin/okr-teams',
    name: 'admin.okr-teams.index',
    component: () => import('@/pages/Admin/OkrTeams/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/okr-teams/create',
    name: 'admin.okr-teams.create',
    component: () => import('@/pages/Admin/OkrTeams/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/okr-teams/:id',
    name: 'admin.okr-teams.edit',
    component: () => import('@/pages/Admin/OkrTeams/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  // Articles

  {
    path: '/admin/articles',
    name: 'admin.articles.index',
    component: () => import('@/pages/Admin/Articles/Index'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },
  {
    path: '/admin/articles/bulk-image-upload',
    name: 'admin.articles.bulk.image.upload',
    component: () => import('@/pages/Admin/Articles/BulkImageUpload'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },
  {
    path: '/admin/articles/create/:id?',
    name: 'admin.articles.create',
    component: () => import('@/pages/Admin/Articles/Create'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/articles/:id',
    name: 'admin.articles.edit',
    component: () => import('@/pages/Admin/Articles/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },
  {
    path: '/admin/catalogues',
    name: 'admin.catalogues.index',
    component: () => import('@/pages/Admin/Catalogues/Index'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/catalogues/create',
    name: 'admin.catalogues.create',
    component: () => import('@/pages/Admin/Catalogues/Create'),
    meta: {
      perimeter: 'MyHpNoFinPerimeter',
    },
  },

  {
    path: '/admin/catalogues/prices/:catalogueId',
    name: 'admin.catalogues.prices',
    component: () => import('@/pages/Admin/Catalogues/ArticlePricesEdit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/catalogues/types/:id',
    name: 'admin.catalogues.types',
    component: () => import('@/pages/Admin/Catalogues/CatalogueTypes'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/catalogues/:id/texts',
    name: 'admin.catalogues.texts',
    component: () => import('@/pages/Admin/Catalogues/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/catalogues/:id/data',
    name: 'admin.catalogues.data',
    component: () => import('@/pages/Admin/Catalogues/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/catalogues/:id/settings',
    name: 'admin.catalogues.settings',
    component: () => import('@/pages/Admin/Catalogues/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/article-types',
    name: 'admin.article-types.index',
    component: () => import('@/pages/Admin/ArticleTypes/Index'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  // {
  //   path: '/admin/article-groups/create',
  //   name: 'admin.article-groups.create',
  //   component: () => import('@/pages/Admin/ArticleGroups/Create'),
  //   meta: {
  //     perimeter: 'MyHpPerimeter',
  //   },
  // },

  {
    path: '/admin/article-types/:id',
    name: 'admin.article-types.edit',
    component: () => import('@/pages/Admin/ArticleTypes/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/article-tags',
    name: 'admin.article-tags.index',
    component: () => import('@/pages/Admin/ArticleTags/Index'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  // {
  //   path: '/admin/article-tags/create',
  //   name: 'admin.article-tags.create',
  //   component: () => import('@/pages/Admin/ArticleTags/Create'),
  //   meta: {
  //     perimeter: 'MyHpPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/admin/article-tags/:id',
  //   name: 'admin.article-tags.edit',
  //   component: () => import('@/pages/Admin/ArticleTags/Edit'),
  //   meta: {
  //     perimeter: 'MyHpPerimeter',
  //   },
  // },

  {
    path: '/admin/service-options',
    name: 'admin.service-options.index',
    component: () => import('@/pages/Admin/ServiceOptions/Index'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/service-options/create',
    name: 'admin.service-options.create',
    component: () => import('@/pages/Admin/ServiceOptions/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/service-options/:id',
    name: 'admin.service-options.edit',
    component: () => import('@/pages/Admin/ServiceOptions/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/funnels',
    name: 'admin.funnels.index',
    component: () => import('@/pages/Admin/Funnels/Index'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/funnels/create',
    name: 'admin.funnels.create',
    component: () => import('@/pages/Admin/Funnels/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/funnels/:id',
    name: 'admin.funnels.edit',
    component: () => import('@/pages/Admin/Funnels/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/myh-settings',
    name: 'admin.myh-settings',
    component: () => import('@/pages/Admin/MyH/Settings/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/myh-footer',
    name: 'admin.myh-footer',
    component: () => import('@/pages/Admin/MyHFooter/Edit'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/customer-tp-template',
    name: 'admin.customer-tp-template',
    component: () => import('@/pages/Admin/SubscriptionTemplates/Customer'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/supplier-tp-template',
    name: 'admin.supplier-tp-template',
    component: () => import('@/pages/Admin/SubscriptionTemplates/Supplier'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/admin/units',
    name: 'admin.units.index',
    component: () => import('@/pages/Admin/Units/Index'),
    meta: {
      perimeter: 'AdminMDTPerimeter',
    },
  },

  {
    path: '/admin/units/create',
    name: 'admin.units.create',
    component: () => import('@/pages/Admin/Units/Create'),
    meta: {
      perimeter: 'AdminMDTPerimeter',
    },
  },

  {
    path: '/admin/units/:id',
    name: 'admin.units.edit',
    component: () => import('@/pages/Admin/Units/Edit'),
    meta: {
      perimeter: 'AdminMDTPerimeter',
    },
  },

  {
    path: '/admin/roles',
    name: 'admin.roles.index',
    component: () => import('@/pages/Admin/Roles/Index'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/roles/create',
    name: 'admin.roles.create',
    component: () => import('@/pages/Admin/Roles/Create'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/roles/:id',
    name: 'admin.roles.edit',
    component: () => import('@/pages/Admin/Roles/Edit'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/import',
    name: 'admin.import.index',
    component: () => import('@/pages/Admin/Import/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/data/activity',
    name: 'data.activity.index',
    component: () => import('@/pages/Data/Activity'),
    meta: {
      perimeter: 'ManagementPerimeter',
    },
  },

  {
    path: '/data/publications',
    name: 'data.publications.index',
    component: () => import('@/pages/Data/TimeTrackingPublications'),
    meta: {
      perimeter: 'ManagementPerimeter',
    },
  },

  {
    path: '/data/company-data',
    name: 'data.company_data.index',
    component: () => import('@/pages/Data/CompanyData'),
    meta: {
      perimeter: 'ManagementPerimeter',
    },
  },

  {
    path: '/data/handover-polls',
    name: 'data.handover-polls.index',
    component: () => import('@/pages/Data/HandoverPolls'),
    meta: {
      perimeter: 'ManagementPerimeter',
    },
  },

  {
    path: '/data/email-fails',
    name: 'data.email-fails.index',
    component: () => import('@/pages/Data/EmailFails'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/data/wl-sync-fails',
    name: 'data.wl-fails.index',
    component: () => import('@/pages/Data/WLSyncErrorLogs'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/quiz/question-sets',
    name: 'admin.question_sets.index',
    component: () => import('@/pages/Admin/Quiz/QuestionSets/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/quiz/question-sets/create',
    name: 'admin.question_sets.create',
    component: () => import('@/pages/Admin/Quiz/QuestionSets/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/quiz/question-sets/:id',
    name: 'admin.question_sets.edit',
    component: () => import('@/pages/Admin/Quiz/QuestionSets/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/quiz/questions/:question_set_id',
    name: 'admin.quiz_questions.index',
    component: () => import('@/pages/Admin/Quiz/Questions/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/quiz/questions/create/:question_set_id',
    name: 'admin.quiz_questions.create',
    component: () => import('@/pages/Admin/Quiz/Questions/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/quiz/questions/edit/:id',
    name: 'admin.quiz_questions.edit',
    component: () => import('@/pages/Admin/Quiz/Questions/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/quiz/players',
    name: 'admin.players.index',
    component: () => import('@/pages/Admin/Quiz/Players'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },
  // Archived Actions
  {
    path: '/admin/archived-actions',
    name: 'admin.archived-actions.index',
    component: () => import('@/pages/Admin/Actions/Archived'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },
  {
    path: '/admin/scrum-categories',
    name: 'admin.scrumCategories.index',
    component: () => import('@/pages/Admin/ScrumCategories/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },
  // Labels
  {
    path: '/admin/labels',
    name: 'admin.labels.index',
    component: () => import('@/pages/Admin/Labels/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/labels/create',
    name: 'admin.labels.create',
    component: () => import('@/pages/Admin/Labels/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/labels/:id',
    name: 'admin.labels.edit',
    component: () => import('@/pages/Admin/Labels/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },
  // Warning heights
  {
    path: '/admin/warning-heights',
    name: 'admin.warning-heights.index',
    component: () => import('@/pages/Admin/WarningHeights/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/warning-heights/create',
    name: 'admin.warning-heights.create',
    component: () => import('@/pages/Admin/WarningHeights/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/warning-heights/:id',
    name: 'admin.warning-heights.edit',
    component: () => import('@/pages/Admin/WarningHeights/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },
  // Mandatory dates
  {
    path: '/admin/mandatory-dates',
    name: 'admin.mandatory-dates.index',
    component: () => import('@/pages/Admin/MandatoryDates/Index'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/mandatory-dates/create',
    name: 'admin.mandatory-dates.create',
    component: () => import('@/pages/Admin/MandatoryDates/Create'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },

  {
    path: '/admin/mandatory-dates/:id',
    name: 'admin.mandatory-dates.edit',
    component: () => import('@/pages/Admin/MandatoryDates/Edit'),
    meta: {
      perimeter: 'AdminHRCPerimeter',
    },
  },
  // Checklist templates
  {
    path: '/admin/checklist-templates',
    name: 'admin.checklist-templates.index',
    component: () => import('@/pages/Admin/ChecklistTemplates/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/checklist-templates/create',
    name: 'admin.checklist-templates.create',
    component: () => import('@/pages/Admin/ChecklistTemplates/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/checklist-templates/:id',
    name: 'admin.checklist-templates.edit',
    component: () => import('@/pages/Admin/ChecklistTemplates/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },
  // Tags
  {
    path: '/admin/tags',
    name: 'admin.tags.index',
    component: () => import('@/pages/Admin/Tags/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tags/create',
    name: 'admin.tags.create',
    component: () => import('@/pages/Admin/Tags/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tags/:id',
    name: 'admin.tags.edit',
    component: () => import('@/pages/Admin/Tags/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  // Surveys
  {
    path: '/admin/surveys',
    name: 'admin.surveys.index',
    component: () => import('@/pages/Admin/Surveys/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/surveys/create/:id?',
    name: 'admin.surveys.create',
    component: () => import('@/pages/Admin/Surveys/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/surveys/:id',
    name: 'admin.surveys.edit',
    component: () => import('@/pages/Admin/Surveys/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  // Certificates
  {
    path: '/admin/certificates',
    name: 'admin.certificates.index',
    component: () => import('@/pages/Admin/ArticleCertificates/Index'),
    meta: {
      perimeter: 'AdminMDTPerimeter',
    },
  },

  {
    path: '/admin/certificates/create/:id?',
    name: 'admin.certificates.create',
    component: () => import('@/pages/Admin/ArticleCertificates/Create'),
    meta: {
      perimeter: 'AdminMDTPerimeter',
    },
  },

  {
    path: '/admin/certificates/:id',
    name: 'admin.certificates.edit',
    component: () => import('@/pages/Admin/ArticleCertificates/Edit'),
    meta: {
      perimeter: 'AdminMDTPerimeter',
    },
  },

];

[
  {
    entity: 'Campaign',
    path: 'campaigns',
    fields: [
      {
        name: 'transport',
        type: 'boolean',
        label: 'Transport campaign',
        default: 0,
      },
    ],
  },
  {
    name: 'Sample room',
    entity: 'SampleRoom',
    path: 'sample-rooms',
    fields: [
      {
        name: 'description',
        type: 'text',
        label: 'Description:',
        default: null,
      },
    ],
  },
  // { entity: 'Tag', path: 'tags', name: 'Company tag' },
  { entity: 'JournalType', path: 'journal-types', name: 'Journal type' },
  { entity: 'ActionType', path: 'action-types', name: 'Action type' },
  { entity: 'PackingType', path: 'packing-types', name: 'Packing type' },
  { entity: 'NkFormat', path: 'nk-formats', name: 'NK format' },
  { entity: 'Language', path: 'languages' },
  // { entity: 'Team', path: 'teams' },
  // { entity: 'Certificate', path: 'certificates' },
  { entity: 'Application', path: 'applications' },
  { entity: 'RawMaterial', path: 'raw-materials', name: 'Raw material', languages: true, perimeter: 'AdminMDTPerimeter' },
  { entity: 'MaterialColor', path: 'material-colors', name: 'Material color', languages: true, perimeter: 'AdminMDTPerimeter' },
  { entity: 'FscCategory', path: 'fsc-categories', name: 'FSC category', languages: true, perimeter: 'AdminMDTPerimeter' },
  { entity: 'PefcCategory', path: 'pefc-categories', name: 'PEFC category', languages: true, perimeter: 'AdminMDTPerimeter' },
  { entity: 'Embossing', path: 'embossings', name: 'Embossing type', languages: true },
  { entity: 'PalletType', path: 'pallet-types', name: 'Pallet type', languages: true, perimeter: 'AdminMDTPerimeter' },
  {
    entity: 'ArticleEmbossingType',
    path: 'article-embossing-types',
    name: 'Article Embossing type',
    languages: true,
    perimeter: 'AdminMDTPerimeter',
    fields: [{
      type: 'boolean',
      name: 'embossing',
      label: 'Embossing',
    }],
  },
  {
    entity: 'CompanySetting',
    path: 'company-settings',
    name: 'Company master data',
    languages: false,
    fields: [{
      type: 'text',
      name: 'value',
      label: 'Value',
    }],
  },
  { entity: 'Format', path: 'formats' },
  { entity: 'Currency', path: 'currencies', perimeter: 'AdminMDTPerimeter' },
  { entity: 'Incoterm', path: 'incoterms' },
  { entity: 'TagGroup', path: 'tag-groups', name: 'Tag group' },
  { entity: 'TruckRequirement', path: 'truck-requirements', name: 'Truck requirement' },
  { entity: 'CoreSpecification', path: 'core-specifications', name: 'Core specification', languages: true, perimeter: 'AdminMDTPerimeter' },
  { entity: 'CoreColor', path: 'core-colors', name: 'Core colors', languages: true, perimeter: 'AdminMDTPerimeter' },
  { entity: 'PackingMaterial', path: 'packing-materials', name: 'Packing material', languages: true, perimeter: 'AdminMDTPerimeter' },
  {
    entity: 'BoxDimension',
    path: 'box-dimensions',
    name: 'Box dimension',
    perimeter: 'AdminMDTPerimeter',
    languages: false,
    fields: [
      {
        type: 'input',
        name: 'height',
        label: 'Height',
      },
      {
        type: 'input',
        name: 'width',
        label: 'Width',
      },
      {
        type: 'input',
        name: 'length',
        label: 'Length',
      },
      {
        type: 'input',
        name: 'weight',
        label: 'Weight',
      },
    ],
  },
  // { entity: 'PublicationTag', path: 'publication-tags', name: 'Publication tag' },
].forEach((el) => {
  const meta = {
    perimeter: el.perimeter || 'AdminPerimeter',
    entity: el.entity,
    path: el.path,
    name: el.name,
    fields: el.fields || [],
    languages: el.languages,
  };
  routes = routes.concat(
    [
      {
        path: `/admin/${el.path}`,
        name: `admin.${el.path}.index`,
        component: () => import('@/pages/Admin/Universal/Index'),
        meta,
      },

      {
        path: `/admin/${el.path}/create`,
        name: `admin.${el.path}.create`,
        component: () => import('@/pages/Admin/Universal/Create'),
        meta,
      },

      {
        path: `/admin/${el.path}/:id`,
        name: `admin.${el.path}.edit`,
        component: () => import('@/pages/Admin/Universal/Edit'),
        meta,
      },
    ],
  );
});

export default routes;



// WEBPACK FOOTER //
// ./src/routes/admin.js